import { Permissions } from '../../core-module/constants/permission.constants';

export interface PermissionConfig {
    roles?: string[];
    permissions?: string[];
}

export const GlobalPermissions = {

    BORROWER_MANAGEMENT: {
        permissions: [Permissions.Management.Borrower.FullControl]
    } as PermissionConfig,

    ROLE_MANAGEMENT: {
        permissions: [Permissions.Management.Role.FullControl]
    } as PermissionConfig,

    MARKETING_MANAGEMENT: {
        permissions: [Permissions.MarketingHub.MarketingResource.FullControl]
    } as PermissionConfig,

} as const;

export function toAppAuthorization(config: PermissionConfig): { userRolesAny?: string[], permissions?: string[] } {
    return {
        userRolesAny: config.roles,
        permissions: config.permissions
    };
}
